/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';
import { maxWidth } from '@mui/system';


/* ++++++++++ --------------- ARTICLE SENTIMENT V2 ANALYTICS - TOP ARTICLES REPORT : STYLES --------------- ++++++++++ */
export default {
    '@global': {
        '.tip-content': {
            textAlign: 'left'
        }
    },
    toparticlesreport: {
        padding: '24px',
        background: '#FFFFFF !important',
        '& .tablereport .title': {
            padding: 0
        },
        '& .cardwrapper': {
            boxShadow: 'none',
            marginBottom: 0,
            '&:hover': {
                boxShadow: 'none !important'
            }
        },
        '& table': {
            tableLayout: 'fixed',
            '& th:first-child, td:first-child': {
                padding: `${pxToEm(16)} !important`
            },
            '& th:nth-child(2), td:nth-child(2)': {
                width: '90% !important'
            },
            '& th:last-child, td:last-child': {
                padding: `${pxToEm(16)} !important`,
                width: '150px !important',
                maxWidth: '150px !important'
            },
        }
    }
};
